import { memo } from 'react';
import { Location } from '../../mechanics/location/Location';
import ImgWithFallback from '../ui/ImgWithFallback';

interface ILocationsItemProps {
    mainClass: string
    handleClick: () => void
    location: Location
}

const LocationsItem = ({ mainClass, handleClick, location }: ILocationsItemProps) => {

    return (
        <div
            className={`${mainClass}__modal-item`}
            onClick={handleClick}
        >
            <ImgWithFallback
                src={location.getBackground().webp}
                fallbackSrc={location.getBackground().img}
                styles={!location.getIsComplete() ? { filter: "grayscale(1)" } : {}} />
            <span>{location.getName()}</span>
        </div>
    );
};

export default memo(LocationsItem);